export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-two-f8038b64c012b909bc7b3930c94626c5.svg";